import { useEffect, useState } from "react";

type Props = {
  headings: { id: string }[];
  topOffset: number;
  bottomOffset: number;
};

const useActiveHeading = ({ headings, topOffset, bottomOffset }: Props) => {
  const [activeHeadingId, setActiveHeadingId] = useState("");

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          const id = entry.target.getAttribute("id") as string;
          if (entry.isIntersecting) {
            setActiveHeadingId(id);
          }
        });
      },
      {
        rootMargin: `${topOffset}px 0px ${bottomOffset}px 0px`,
        threshold: 1,
      }
    );

    headings.forEach(({ id }) => {
      const targetEl = document.getElementById(id);
      if (targetEl) {
        observer.observe(targetEl);
      }
    });

    return () => {
      headings.forEach(({ id }) => {
        const targetEl = document.getElementById(id);
        if (targetEl) observer.unobserve(targetEl);
      });
    };
  }, [headings, topOffset, bottomOffset]);

  return activeHeadingId;
};

export { useActiveHeading };
